import React from 'react';
import ManagementSectionManager, {
  type ManagerFieldDef,
  type ManagerColumnDef,
} from '@/components/ManagementSectionManager';

/**
 * Team manager (management websites only).
 */

const fields: ManagerFieldDef[] = [
  { name: 'name', label: 'Name', type: 'text', required: true, maxLength: 120 },
  { name: 'roleTitle', label: 'Role / Title', type: 'text', maxLength: 120 },
  { name: 'bio', label: 'Short Bio', type: 'textarea', maxLength: 1000, rows: 3 },
  {
    name: 'imageUrl',
    label: 'Photo',
    type: 'image',
    aspectRatio: 1,
    circular: true,
    helpText: 'Square crop — shown in a circle on the website.',
  },
  {
    name: 'socials',
    label: 'Social Links',
    type: 'socials',
    rows: 3,
    helpText: 'One per line: Label | URL  (e.g. "Instagram | https://instagram.com/…")',
  },
];

const columns: ManagerColumnDef[] = [
  {
    name: 'name',
    label: 'Member',
    render: (item) => (
      <div className="flex items-center gap-3">
        {item.imageUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.imageUrl} alt="" className="w-9 h-9 rounded-full object-cover shrink-0" />
        ) : (
          <div className="w-9 h-9 rounded-full bg-muted shrink-0" />
        )}
        <span>
          <span className="font-medium block">{item.name}</span>
          {item.roleTitle && (
            <span className="text-muted-foreground text-xs">{item.roleTitle}</span>
          )}
        </span>
      </div>
    ),
  },
  {
    name: 'bio',
    label: 'Bio',
    render: (item) => (
      <span className="text-muted-foreground">
        {item.bio?.length > 80 ? `${item.bio.slice(0, 80)}…` : item.bio || '—'}
      </span>
    ),
  },
];

const TeamManager: React.FC = () => (
  <ManagementSectionManager
    title="Team"
    description=""
    apiPath="/api/team"
    sectionKey="team"
    itemLabel="team member"
    fields={fields}
    columns={columns}
    toggleField={{ name: 'isActive' }}
    emptyHint="No team members yet. Add the people who make your company work."
  />
);

export default TeamManager;
